/* ============================================================
   Pholoh nav drawer — open it UNDER the header (Vicinity-style).
   The CSS makes #NavDrawer full-width and drop down; this just pins its
   top edge to the live bottom of the sticky header group each time it
   opens (so it clears the announcement bar + header at any scroll pos).
   ============================================================ */
(function () {
  'use strict';
  var nav = document.getElementById('NavDrawer');
  if (!nav) return;

  function headerBottom() {
    var h = document.querySelector('.pholoh-header-stuck');
    if (!h) return 0;
    return Math.max(0, Math.round(h.getBoundingClientRect().bottom));
  }

  function sync() {
    if (nav.classList.contains('drawer--is-open')) {
      nav.style.top = headerBottom() + 'px';
    }
  }

  new MutationObserver(sync).observe(nav, { attributes: true, attributeFilter: ['class'] });
  window.addEventListener('resize', sync);
})();
